export const dlSubscribeSuccessEvent = (target, email) => {
    window.dataLayer.push({
        event: 'subscribe',
        contact: {
            target,
            email
        },
        customer: {
            email
        },
        visitor: {
            accept_marketings: true
        }
    });
};
